export function escapeKey(key: string): string {
	return key.replaceAll("~", "~0").replaceAll("/", "~1");
}
